import React, { PropTypes } from 'react';

import './style.scss';

const ReferralFormProviderList = (props) => {
  const { name, logo, description } = props;

  return (
    <div className="ReferralFormProviderList">
      {logo &&
      <div className="service-logo">
        <img src={logo} />
      </div>}
      <h4>{name}</h4>
      <p>{description}</p>
    </div>
  );
};



ReferralFormProviderList.propTypes = {
  name: PropTypes.string,
  logo: PropTypes.string,
  description: PropTypes.string
};

export default ReferralFormProviderList;




/** WEBPACK FOOTER **
 ** ./src/members/Main/Referral/ReferralForm/ReferralFormProviderList/index.js
 **/